export const getWalletHistoric = (state) => state.walletHistoric
export const getTotalTransactions = (state) => state.totalTransactions
export const getDiscountCoupons = (state) => state.discountCoupons
export const getCouponsCampaign = (state) => state.couponsCampaign